/** 画册可保存的角色参考图上限 */
export const COMIC_CHARACTER_REF_STORAGE_MAX = 6

/** 单格分镜可覆盖画册的参考图上限 */
export const COMIC_PANEL_REF_STORAGE_MAX = 3

export function normalizeReferenceUrls(raw: unknown, max: number): string[] {
  if (!Array.isArray(raw) || max <= 0) return []
  const seen = new Set<string>()
  const out: string[] = []
  for (const item of raw) {
    if (typeof item !== 'string') continue
    const u = item.trim()
    if (!u || seen.has(u)) continue
    seen.add(u)
    out.push(u)
    if (out.length >= max) break
  }
  return out
}

export function normalizeCharacterReferenceUrls(raw: unknown): string[] {
  return normalizeReferenceUrls(raw, COMIC_CHARACTER_REF_STORAGE_MAX)
}

export function normalizePanelReferenceUrls(raw: unknown): string[] {
  return normalizeReferenceUrls(raw, COMIC_PANEL_REF_STORAGE_MAX)
}
